var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "my-16 px-6" }, [
    _c("div", { staticClass: "container mx-auto" }, [
      _c("h3", [_vm._v("Reviews")]),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "grid lg:grid-cols-2 gap-12 mt-4 mb-6" },
        [
          _vm._t("default"),
          _vm._v(" "),
          _vm._l(_vm.reviews, function (review) {
            return _c("div", [
              _c("p", { staticClass: "font-semibold text-gray-700" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(review.seat.customer.first_name) +
                    " " +
                    _vm._s(review.seat.customer.last_name) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("p", { staticClass: "text-sm text-primary-600" }, [
                _vm._v(
                  "\n                    " +
                    _vm._s(review.event_date.event_date) +
                    "\n                "
                ),
              ]),
              _vm._v(" "),
              _c("div", {
                staticClass: "my-2",
                domProps: { innerHTML: _vm._s(review.body) },
              }),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "flex text-primary-600" },
                _vm._l(review.rating, function (n) {
                  return _c(
                    "svg",
                    {
                      staticClass: "w-5 h-5",
                      attrs: {
                        fill: "currentColor",
                        viewBox: "0 0 20 20",
                        xmlns: "http://www.w3.org/2000/svg",
                      },
                    },
                    [
                      _c("path", {
                        attrs: {
                          d: "M9.049 2.927c.3-.921 1.603-.921 1.902 0l1.07 3.292a1 1 0 00.95.69h3.462c.969 0 1.371 1.24.588 1.81l-2.8 2.034a1 1 0 00-.364 1.118l1.07 3.292c.3.921-.755 1.688-1.54 1.118l-2.8-2.034a1 1 0 00-1.175 0l-2.8 2.034c-.784.57-1.838-.197-1.539-1.118l1.07-3.292a1 1 0 00-.364-1.118L2.98 8.72c-.783-.57-.38-1.81.588-1.81h3.461a1 1 0 00.951-.69l1.07-3.292z",
                        },
                      }),
                    ]
                  )
                }),
                0
              ),
              _vm._v(" "),
              review.response
                ? _c(
                    "div",
                    { staticClass: "px-6 text-gray-500 mt-3 text-sm" },
                    [
                      _c("div", {
                        domProps: { innerHTML: _vm._s(review.response) },
                      }),
                      _vm._v(" "),
                      _c("p", { staticClass: "font-semibold mt-1" }, [
                        _vm._v(
                          "\n                        Nomad\n                    "
                        ),
                      ]),
                    ]
                  )
                : _vm._e(),
            ])
          }),
        ],
        2
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "flex justify-center" },
        [
          _vm.showLoadButton
            ? _c(
                "form-button",
                {
                  nativeOn: {
                    click: function ($event) {
                      return _vm.loadMore.apply(null, arguments)
                    },
                  },
                },
                [_vm._v("\n                Load More\n            ")]
              )
            : _vm._e(),
        ],
        1
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }